var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { PulseLoader as Spinner } from 'react-spinners';
import { classNames } from '@shapeable/utils';
import { DottedLine } from './dotted-line';
import { Icon } from './icon';
import { useTheme } from '../hooks/use-theme';
import { useComponentPropsFor } from '../context/component-props-context';
var cls = classNames('content-tab');
export var ContentTabDefaultProps = {
  isActive: false,
  isLast: false,
  isFirst: false,
  colors: {
    text: 'text',
    border: 'strong',
    hover: {
      text: 'strong'
    }
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    align-self: stretch;\n    cursor: pointer;\n    flex-wrap: nowrap;\n    box-sizing: border-box;\n    font-weight: 400; \n    padding: 0;\n    flex-grow: 1;\n    text-align: center;\n    font-family: ", ";\n    background-color: transparent;\n    border: none;\n    height: ", ";\n    font-size: ", "; \n    padding-bottom: ", ";\n    border-bottom-width: 1px;\n    border-bottom-style: solid;\n\n    ", ";\n\n    ", "\n\n\n    ", "\n  "], ["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    align-self: stretch;\n    cursor: pointer;\n    flex-wrap: nowrap;\n    box-sizing: border-box;\n    font-weight: 400; \n    padding: 0;\n    flex-grow: 1;\n    text-align: center;\n    font-family: ", ";\n    background-color: transparent;\n    border: none;\n    height: ", ";\n    font-size: ", "; \n    padding-bottom: ", ";\n    border-bottom-width: 1px;\n    border-bottom-style: solid;\n\n    ", ";\n\n    ", "\n\n\n    ", "\n  "])), theme.FONT('sans'), theme.UNIT(14), theme.FONT_SIZE(14), theme.UNIT(3), theme.APPLY_COLORS, function (_a) {
    var isActive = _a.isActive;
    return isActive && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      cursor: default;\n      svg {\n        margin-top: -1px;\n      }\n    "], ["\n      cursor: default;\n      svg {\n        margin-top: -1px;\n      }\n    "])));
  }, function (_a) {
    var isActive = _a.isActive;
    return isActive && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      border-bottom-width: 4px;\n      padding-bottom: ", ";\n      font-weight: 500;\n    "], ["\n      border-bottom-width: 4px;\n      padding-bottom: ", ";\n      font-weight: 500;\n    "])), theme.UNIT(2, 1));
  })
});
var BodyStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    justify-content: center;\n    white-space: nowrap;\n    align-items: center;\n    flex-grow: 1;\n    padding: 0 ", ";\n    gap: ", ";\n  "], ["\n    display: flex;\n    justify-content: center;\n    white-space: nowrap;\n    align-items: center;\n    flex-grow: 1;\n    padding: 0 ", ";\n    gap: ", ";\n  "])), theme.UNIT(3), theme.UNIT(1))
});
var ContentTabCountStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    color: ", ";\n    font-size: 0.9em;\n  "], ["\n    color: ", ";\n    font-size: 0.9em;\n  "])), theme.COLOR('subtle'))
});
var DottedLineStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    flex-grow: 0;\n    flex-shrink: 1;\n  "], ["\n    flex-grow: 0;\n    flex-shrink: 1;\n  "])))
});
var SpinnerStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var LabelAndIconStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    gap: ", ";\n    max-height: 30px;\n  "], ["\n    display: flex;\n    align-items: center;\n    gap: ", ";\n    max-height: 30px;\n  "])), theme.UNIT(3))
});
var IconLabelStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    white-space: normal; \n    word-wrap: break-word; \n    text-align: start;\n    width: 100%;\n    align-text: start !important;\n  "], ["\n    white-space: normal; \n    word-wrap: break-word; \n    text-align: start;\n    width: 100%;\n    align-text: start !important;\n  "])))
});
var IconStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), theme.FILL('strong'))
});
// -------- Components -------->
var My = {
  NAME: 'ContentTab',
  Container: styled.button(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled.span(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Spinner: styled(Spinner)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), SpinnerStyles),
  DottedLine: styled(DottedLine)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), DottedLineStyles),
  ContentTabCount: styled.span(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), ContentTabCountStyles),
  LabelAndIcon: styled.div(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), LabelAndIconStyles),
  Icon: styled(Icon)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  IconLabel: styled.span(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), IconLabelStyles)
};
export var ContentTab = function (props) {
  var _a, _b;
  var _c = useComponentPropsFor(My.NAME, ContentTabDefaultProps, props),
    className = _c.className,
    isActive = _c.isActive,
    onClick = _c.onClick,
    isLast = _c.isLast,
    count = _c.count,
    isLoading = _c.isLoading,
    icon = _c.icon,
    label = _c.label,
    colors = _c.colors;
  var theme = useTheme();
  return React.createElement(My.Container, {
    onClick: onClick,
    colors: colors,
    isActive: isActive,
    isLast: isLast,
    className: cls.name(className)
  }, React.createElement(My.Body, null, React.createElement(My.LabelAndIcon, null, icon && React.createElement(My.Icon, {
    size: 30,
    color: "strong"
  }, icon), label && React.createElement(My.IconLabel, null, label)), isLoading ? React.createElement(Spinner, {
    color: (_b = (_a = theme === null || theme === void 0 ? void 0 : theme.light) === null || _a === void 0 ? void 0 : _a.color) === null || _b === void 0 ? void 0 : _b.primary,
    size: 6
  }) : !!count && React.createElement(My.ContentTabCount, {
    count: count
  }, "(", count, ")")));
};
ContentTab.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18;